<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a">Contents</p>
<p class="tocb"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/chapter01">1. On the Homefront: 1861</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. On the Homefront: 1862</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. On the Homefront: 1863</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. On the Homefront: 1864</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. On the Homefront: 1865</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Tar Heels to the Front</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Reconstruction</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Remembrance</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Looking for the Civil War in North Carolina Today</span></p>
<p class="toct"><span href="#/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9926c6d4